import { Provider as ReduxProvider } from 'react-redux';

import { store } from './store';

export const GlobalStateProvider = ({ children }: { children: React.ReactNode }) => {
  return <ReduxProvider store={store}>{children}</ReduxProvider>;
};
